import { render, staticRenderFns } from "./templateDetail.vue?vue&type=template&id=df59befe"
import script from "./templateDetail.vue?vue&type=script&lang=js"
export * from "./templateDetail.vue?vue&type=script&lang=js"
import style0 from "./templateDetail.vue?vue&type=style&index=0&id=df59befe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports